import Chance from "chance";

const chance = new Chance();

const industry = [
  "Accommodation",
  "Food Services",
  "Administrative",
  "Support",
  "Waste Management",
  "Remediation Services",
  "Agriculture",
  "Forestry",
  "Fishing",
  "Hunting",
  "Arts",
  "Entertainment",
  "Recreation",
  "Construction",
  "Educational Services",
  "Finance",
  "Insurance",
  "Health Care",
  "Social Assistance",
  "Information",
  "Cultural Industries",
  "Management of Companies",
  "Enterprises",
  "Manufacturing",
  "Mining",
  "Quarrying",
  "Oil",
  "Gas Extraction",
  "Other Services",
  "Professional",
  "Scientific",
  "Technical Services",
  "Public Administration",
  "Real Estate",
  "Rental",
  "Leasing",
  "Retail Trade",
  "Transportation",
  "Warehousing",
  "Utilities",
  "Wholesale Trade"
];
const products = [
  "Peak Prevention",
  "Coincident Peaks",
  "Bill Reduction",
  "Go Green"
];
const country = chance.pickone(["Canada", "USA"]);

export const generateAccountData = async ({ offset, limit = 10 }) => {
  return new Promise(resolve => {
    setTimeout(() => {
      let results = chance.n(chance.customer, limit);
      resolve({
        data: results,
        meta: {
          count: results.length,
          offset: offset,
          limit: limit
        }
      });
    }, 800);
  });
};

export const meterTypes = ["Z3Controls NetMeter"];

export const defaultProvisionMeter = {
  id: 0,
  customer: {
    customerName: ""
  },
  meterType: "",
  meterId: "",
  dateProvisioned: "",
  notes: ""
};

const meterReading = () => {
  return {
    date: chance.date({ string: true, year: 2020 }),
    pulseCount: chance.natural({ min: 90, max: 300 })
  };
};

const generateMeterReadings = () => {
  const readings = [];
  for (let i = 0; i < chance.natural({ min: 1, max: 8 }); i++) {
    readings.push(meterReading());
  }
  return readings;
};

chance.mixin({
  meter: () => {
    return {
      id: chance.fbid(),
      customer: chance.account(),
      meterType: chance.pickone(meterTypes),
      meterId: chance.fbid(),
      dateProvisioned: chance.date({ string: true, year: 2020 }),
      notes: "",
      ip: chance.ip(),
      accessToken: chance.fbid(),
      meterReadings: generateMeterReadings()
    };
  },
  account: () => {
    return {
      id: chance.fbid(),
      customerName: chance.company(),
      industry: chance.pickone(industry),
      address: chance.address(),
      city: chance.city(),
      country,
      state: country === "USA" ? chance.state({ full: true }) : null,
      province: country === "Canada" ? chance.province({ full: true }) : null,
      users: [
        {
          id: chance.fbid(),
          firstName: chance.first(),
          lastName: chance.last()
        },
        {
          id: chance.fbid(),
          firstName: chance.first(),
          lastName: chance.last()
        },
        {
          id: chance.fbid(),
          firstName: chance.first(),
          lastName: chance.last()
        },
        {
          id: chance.fbid(),
          firstName: chance.first(),
          lastName: chance.last()
        }
      ],
      products: [
        {
          id: chance.fbid(),
          product: chance.pickone(products)
        },
        {
          id: chance.fbid(),
          product: chance.pickone(products)
        },
        {
          id: chance.fbid(),
          product: chance.pickone(products)
        }
      ],
      accounts: [
        {
          id: chance.fbid(),
          account: chance.company()
        },
        {
          id: chance.fbid(),
          account: chance.company()
        }
      ]
    };
  }
});

export default async ({ offset, limit = 10 }) => {
  return new Promise(resolve => {
    setTimeout(() => {
      let results = chance.n(chance.meter, limit);
      resolve({
        data: results,
        meta: {
          count: results.length,
          offset: offset,
          limit: limit
        }
      });
    }, 800);
  });
};

export const defaultEnpoweredAccount = {
  id: 0,
  name: "",
  businessAddress: {
    country: "",
    areaCode: "",
    state: "",
    addressLine: "",
    city: ""
  },
  billingAddress: {
    country: "",
    areaCode: "",
    state: "",
    addressLine: "",
    city: ""
  },
  activeServices: {},
  locations: []
};
